export default __webpack_public_path__ + "static/media/facebook.41e75873.png";